import { createFileRoute, redirect } from '@tanstack/react-router'
import { DataImportScreen } from '@/features/data-imports/data-import-screen'
import { mayUseDataImport } from '@/lib/data-import-access'

/**
 * Route shell for the company's data import. The guard asks the API which
 * sheets this user may import and keeps out a user it offers none; the API
 * checks every request it receives. `?sheet=` opens the screen with that sheet
 * chosen, when the API offers it.
 */
export const Route = createFileRoute('/_authenticated/settings/data-import')({
  validateSearch: (search: Record<string, unknown>) => ({
    sheet: typeof search.sheet === 'string' ? search.sheet : undefined,
  }),
  beforeLoad: async ({ context }) => {
    if (!(await mayUseDataImport(context.queryClient))) {
      throw redirect({ to: '/' })
    }
  },
  component: DataImportRoute,
})

function DataImportRoute() {
  const { sheet } = Route.useSearch()
  return <DataImportScreen initialSheet={sheet} />
}
